<template>
    <div>
        <v-container>
            <v-row>
              <div class="subtitle-2">納品が完了した依頼 / Completed Requests</div>  
            </v-row>
            <v-row no-gutters align="center" justify="center">
                <v-col cols="4" class="">
                    <v-text-field
                        label="チケット番号で検索"
                        solo
                        append-outer-icon="mdi-magnify"
                        v-model="searchTicketNumber"
                        clear-icon="mdi-close-circle"
                        clearable
                        @click:append-outer="searchClicked()"
                        @click:clear="clearSearchResults()"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col>
                    <!-- search results -->
                    <h5 v-if="searchResult" class="my-3">Search Result:</h5>
                    <v-row v-if="feedback" class="red--text mb-10">{{feedback}}</v-row>
                    <v-card v-if="searchResult" class="body-2 mb-2" hover>
                        <v-container>
                            <v-row no-gutters align="center" justify="center" class="pa-1" style="min-height: 80px">
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="my-2">
                                            <v-btn 
                                            x-small 
                                            class="primary info--text" 
                                            @click="jumpToTicketDetail(searchResult.ticket_number)"
                                            >
                                                詳細
                                            </v-btn>
                                        </v-row>
                                        <v-row align="center" justify="center">
                                            {{searchResult.ticket_number}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="5" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{searchResult.ticket_subject}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="2" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Price:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{searchResult.price}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="2" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Completed@
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{searchResult.hand_in_time}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="2" class="">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            submitted by:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                           {{searchResult.submitted_by}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                    <v-divider v-if="searchResult" class="my-5"></v-divider>
                     <!-- first 15 results ordered by ticket number -->
                    <v-card v-for="(ticket,index) in completedTickets" :key="index" class="body-2 mb-2" hover>
                        <v-container>
                            <v-row no-gutters align="center" justify="center" class="pa-1" style="min-height: 80px">
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="my-2">
                                            <v-btn 
                                            x-small 
                                            class="primary info--text" 
                                            @click="jumpToTicketDetail(ticket.ticket_number)"
                                            >
                                                詳細
                                            </v-btn>
                                        </v-row>
                                        <v-row align="center" justify="center">
                                            {{ticket.ticket_number}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="5" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{ticket.ticket_subject}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="1" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Price:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{ticket.price}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="2" class="right-border">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            Completed@
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{formatDate(ticket.hand_in_time)}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                                <v-col cols="6" sm="6" md="3" class="">
                                    <v-container>
                                        <v-row align="center" justify="center" class="pa-1">
                                            submitted by:
                                        </v-row>
                                        <v-row align="center" justify="center" class="pa-1">
                                            {{ticket.submitted_by}}
                                        </v-row>
                                    </v-container>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db} from '@/fb'

export default {
    name:'assignedPanel',
    props:['completedPanelKey'],
    data(){
        return{
            completedTickets:[],
            lastVisibleTicket:null,
            searchTicketNumber:null,
            searchResult:null,

            feedback:null,
        }
    },
    methods:{
        formatDate(dateNow){
            let date = new Date(dateNow);
            return String(date.getFullYear())+'-'+String(date.getMonth()+1)+'-'+String(date.getDate())+' '+String(date.getHours())+':'+String(date.getMinutes())
        },
        searchClicked(){
            let ref_search = db.collection('ticket_completed').where('ticket_number','==',parseInt(this.searchTicketNumber))
            ref_search.get().then(snap=>{
                if(snap.empty){
                    this.feedback = 'Ticket does not exist..'
                }
                else{
                    this.feedback = null;
                    snap.forEach(doc=>{
                        this.searchResult = doc.data()
                    })
                }
                
            })
        },
        clearSearchResults(){
            this.$emit('update-completed-panel',this.completedPanelKey+1)
        },
        jumpToTicketDetail(ticket_number){
            let ref = db.collection('reports').where('id','==',ticket_number)
            ref.get().then(snap=>{
                if(!snap.empty){
                    snap.forEach(doc=>{
                        this.$router.push({name:'TicketDetail', params:{id:doc.id,ticket_id:doc.data().id}})
                    })
                }
            })
        }
    },
    created(){
        let ref = db.collection('ticket_completed').orderBy('ticket_number','desc').limit(15)
        ref.get().then(snap=>{
            this.lastVisibleTicket = snap.docs[snap.docs.length-1]
            snap.forEach(doc=>{
                this.completedTickets.push(doc.data())
            })
        })
    }
}
</script>